import React from 'react';
import BookForm from './../states/BookForm';

const BookContext = React.createContext();
const BookProvider = ({children})=>{
	const bookForm = BookForm();
	return (<BookContext.Provider value={{...bookForm}}>{children}</BookContext.Provider>);
}

export {BookProvider, BookContext}; 